<template>
  <div
    class="assistant-bubble !flex !h-fit !min-w-0 !flex-col !items-start !justify-between !gap-3 !rounded-br-sm-md !rounded-tl-sm-md !rounded-tr-sm-md !bg-white !bg-opacity-60 !px-7 !py-6"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AssistantStyleWrapper',
};
</script>
